$(document).ready(function(){
    $('.ns-about-slider').each(function(){
        const $wrap = $(this).children(), lerp = (start, end, t) => start + (end - start) * t;

        let cursorPosX = null, cursorPosY = null, globalOffsetX = 0, globalOffsetY = 0;

        $(document).mousemove(function(e) {
            const blockOffset = $wrap.offset();
            const blockWidth = $wrap.width();
            const blockHeight = $wrap.height();

            const centerX = blockOffset.left + blockWidth / 2;
            const centerY = blockOffset.top + blockHeight / 2;

            const cursorX = e.pageX;
            const cursorY = e.pageY;

            if (cursorY < centerY) {
                cursorPosY = 'top';
            } else if (cursorY > centerY) {
                cursorPosY = 'bottom';
            }

            if (cursorX < centerX) {
                cursorPosX = 'left';
            } else if (cursorX > centerX) {
                cursorPosX = 'right';
            }
        });

        const $canvas = $(this).find('canvas'),
            canvas = $canvas[0],
            ctx = canvas.getContext("2d");

        const img = new Image();
        img.src = '/img/ns/about/first.jpg';

        img.onload = () => {
            canvas.width = $wrap.width();
            canvas.height = $wrap.height();

            let squareWidth = 900 / 976 * $wrap.width();
            let squareHeight= 900 / 976 * $wrap.height();

            let points = [
                { x: 0.35, y: 0 },
                { x: 0.8, y: 0.5 },
                { x: 0.35, y: 1 },
                { x: 0, y: 0.5 }
            ];

            if ($(window).outerWidth() < 575) {
                squareWidth = 600;
                squareHeight = 400;
            } else if ($(window).outerWidth() < 768) {
                squareWidth = 700;
                squareHeight = 400;
            } else if ($(window).outerWidth() < 992){
                squareWidth = 900;
                squareHeight= 600;
            }

            const animatedPoints = points.map(point => ({ ...point, dx: 0, dy: 0 }));

            const updateGlobalOffsets = () => {
                let targetGlobalX = 0;
                let targetGlobalY = 0;

                if (cursorPosX === 'left') {
                    targetGlobalX = -0.005;
                } else if (cursorPosX === 'right') {
                    targetGlobalX = 0.005;
                }

                if (cursorPosY === 'top') {
                    targetGlobalY = -0.005;
                } else if (cursorPosY === 'bottom') {
                    targetGlobalY = 0.005;
                }

                // Плавный переход для глобального смещения
                globalOffsetX = lerp(globalOffsetX, targetGlobalX, 0.05);
                globalOffsetY = lerp(globalOffsetY, targetGlobalY, 0.05);
            };

            const updatePoints = () => {
                updateGlobalOffsets();

                animatedPoints.forEach((point, i) => {
                    // Плавное изменение локальных точек
                    point.dx = lerp(point.dx, Math.sin(Date.now() / 500 + i) * 0.005 + globalOffsetX, 0.1);
                    point.dy = lerp(point.dy, Math.cos(Date.now() / 700 + i) * 0.005 + globalOffsetY, 0.1);
                });
            };

            const calculateScaledPoints = () => {
                const centerX = (canvas.width - squareWidth) / 2;
                const centerY = (canvas.height - squareHeight) / 2;
                return animatedPoints.map(point => ({
                    x: centerX + (point.x + point.dx) * squareWidth,
                    y: centerY + (point.y + point.dy) * squareHeight
                }));
            };

            const drawImageCover = function(ctx, img, rectX, rectY, rectWidth, rectHeight) {
                const imgRatio = img.width / img.height; // Соотношение сторон изображения
                const rectRatio = rectWidth / rectHeight; // Соотношение сторон прямоугольника

                let drawWidth, drawHeight;

                if (imgRatio > rectRatio) {
                    // Изображение шире прямоугольника
                    drawWidth = rectHeight * imgRatio;
                    drawHeight = rectHeight;
                } else {
                    // Изображение выше прямоугольника
                    drawWidth = rectWidth;
                    drawHeight = rectWidth / imgRatio;
                }

                const offsetX = rectX - (drawWidth - rectWidth) / 2; // Смещение по горизонтали
                const offsetY = rectY - (drawHeight - rectHeight) / 2; // Смещение по вертикали

                ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            };

            const draw = function () {
                const scaledPoints = calculateScaledPoints();

                ctx.clearRect(0, 0, canvas.width, canvas.height);

                drawImageCover(ctx, img, 0, 0, canvas.width, canvas.height);
                //ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'color-dodge';

                const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
                gradient.addColorStop(0, 'rgba(147, 197, 222, 0.3)');
                gradient.addColorStop(1, 'rgba(79, 106, 120, 0.3)');

                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'color-burn';
                ctx.globalAlpha = 0.8;

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(scaledPoints[0].x, scaledPoints[0].y);

                scaledPoints.forEach(point => {
                    ctx.lineTo(point.x, point.y);
                });

                ctx.closePath();
                ctx.clip();

                ctx.fillStyle = '#1E3D4F';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalAlpha = 0.1;
                ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'source-over';
                ctx.globalAlpha = 1;
                ctx.restore();

                updatePoints();

                requestAnimationFrame(draw);
            };

            draw();
        };
    });

    $('.ns-section_blog-first').each(function(){
        const $wrap = $(this).children(), lerp = (start, end, t) => start + (end - start) * t;

        let cursorPosX = null, cursorPosY = null, globalOffsetX = 0, globalOffsetY = 0;

        $(document).mousemove(function(e) {
            const blockOffset = $wrap.offset();
            const blockWidth = $wrap.width();
            const blockHeight = $wrap.height();

            const centerX = blockOffset.left + blockWidth / 2;
            const centerY = blockOffset.top + blockHeight / 2;

            const cursorX = e.pageX;
            const cursorY = e.pageY;

            if (cursorY < centerY) {
                cursorPosY = 'top';
            } else if (cursorY > centerY) {
                cursorPosY = 'bottom';
            }

            if (cursorX < centerX) {
                cursorPosX = 'left';
            } else if (cursorX > centerX) {
                cursorPosX = 'right';
            }
        });

        const $slide  = $(this),
            $canvas = $(this).find('canvas'),
            canvas = $canvas[0],
            ctx = canvas.getContext("2d");

        $slide.height($wrap.height());

        const img = new Image();
        img.src = $canvas.attr('data-src');

        img.onload = () => {
            canvas.width = $wrap.width();
            canvas.height = $wrap.height();

            let squareWidth = 1075 / 1320 * $wrap.width();
            let squareHeight= 878 / 976 * $wrap.height();

            let points = [
                { x: 0.32, y: 0 },
                { x: 0.95, y: 0.4 },
                { x: 0.57, y: 1 },
                { x: 0.05, y: 0.65 }
            ];

            if ($(window).outerWidth() < 576){
                squareWidth = 450;
                squareHeight = 400;
            } else if ($(window).outerWidth() < 768){
                squareWidth = 500;
                squareHeight = 500;
            } else if ($(window).outerWidth() < 992){
                squareWidth = 800;
                squareHeight = 800;

                points = [
                    { x: 0.32, y: 0 },
                    { x: 1, y: 0.4 },
                    { x: 0.57, y: 1 },
                    { x: 0.05, y: 0.65 }
                ];
            }

            const animatedPoints = points.map(point => ({ ...point, dx: 0, dy: 0 }));

            const updateGlobalOffsets = () => {
                let targetGlobalX = 0;
                let targetGlobalY = 0;

                if (cursorPosX === 'left') {
                    targetGlobalX = -0.005;
                } else if (cursorPosX === 'right') {
                    targetGlobalX = 0.005;
                }

                if (cursorPosY === 'top') {
                    targetGlobalY = -0.005;
                } else if (cursorPosY === 'bottom') {
                    targetGlobalY = 0.005;
                }

                // Плавный переход для глобального смещения
                globalOffsetX = lerp(globalOffsetX, targetGlobalX, 0.05);
                globalOffsetY = lerp(globalOffsetY, targetGlobalY, 0.05);
            };

            const updatePoints = () => {
                updateGlobalOffsets();

                animatedPoints.forEach((point, i) => {
                    // Плавное изменение локальных точек
                    point.dx = lerp(point.dx, Math.sin(Date.now() / 500 + i) * 0.005 + globalOffsetX, 0.1);
                    point.dy = lerp(point.dy, Math.cos(Date.now() / 700 + i) * 0.005 + globalOffsetY, 0.1);
                });
            };

            const calculateScaledPoints = () => {
                const centerX = (canvas.width - squareWidth) / 2;
                const centerY = (canvas.height - squareHeight) / 2;
                return animatedPoints.map(point => ({
                    x: centerX + (point.x + point.dx) * squareWidth,
                    y: centerY + (point.y + point.dy) * squareHeight
                }));
            };

            const drawImageCover = function(ctx, img, rectX, rectY, rectWidth, rectHeight) {
                const imgRatio = img.width / img.height; // Соотношение сторон изображения
                const rectRatio = rectWidth / rectHeight; // Соотношение сторон прямоугольника

                let drawWidth, drawHeight;

                if (imgRatio > rectRatio) {
                    // Изображение шире прямоугольника
                    drawWidth = rectHeight * imgRatio;
                    drawHeight = rectHeight;
                } else {
                    // Изображение выше прямоугольника
                    drawWidth = rectWidth;
                    drawHeight = rectWidth / imgRatio;
                }

                const offsetX = rectX - (drawWidth - rectWidth) / 2; // Смещение по горизонтали
                const offsetY = rectY - (drawHeight - rectHeight) / 2; // Смещение по вертикали

                ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            };

            const draw = function () {
                const scaledPoints = calculateScaledPoints();

                ctx.clearRect(0, 0, canvas.width, canvas.height);
                drawImageCover(ctx, img, 0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'color-dodge';

                const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
                gradient.addColorStop(0, 'rgba(147, 197, 222, 0.3)');
                gradient.addColorStop(1, 'rgba(79, 106, 120, 0.3)');

                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'plus-darker';

                ctx.save();
                ctx.beginPath();
                ctx.moveTo(scaledPoints[0].x, scaledPoints[0].y);

                scaledPoints.forEach(point => {
                    ctx.lineTo(point.x, point.y);
                });

                ctx.closePath();
                ctx.clip();

                ctx.globalCompositeOperation = "multiply";

                ctx.fillStyle = $canvas.attr('data-fill');
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalAlpha = 0.1;
                ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'source-over';
                ctx.restore();

                updatePoints();

                requestAnimationFrame(draw);
            };

            draw();
        };
    });

    $('.js-ns-layout-tab-trigger').click(function(){
        if (!$(this).hasClass('_active')){
            $('.js-ns-layout-tab-trigger').removeClass('_active');
            $(this).addClass('_active');

            $('.js-ns-layout-tab-content').removeClass('_active');
            $('.js-ns-layout-tab-content[data-tab="' + $(this).attr('data-tab') + '"]').addClass('_active');
        }
    })
});
